module.exports = __webpack_public_path__ + "img/download-blue.066eec95.svg";